import { Link } from "react-router-dom";
import { useAuth } from "../../../hooks/useAuth";
import { MdKeyboardArrowRight } from "react-icons/md";
import './FolhaPagamento.css';
import ReactModal from "react-modal";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Box } from "../../box";
import { usePayroll } from "../../../hooks/usePayroll";
import moment from "moment";
import { Select } from "../../select";
import { formatValueToMonetary } from "../../../utils/formatter";
import { useAccount } from "../../../hooks/useAccount";
import { PageHeader } from "../../page-header";

export default function () {
  const { user } = useAuth();
  const { loading, schedulePayrollPayment, listPayrolls, payrolls, getDetailedPayroll, detailedPayroll } = usePayroll();
  const { avaliableBalance, getBalance } = useAccount();
  const [isSchedulePaymentOpen, setIsSchedulePaymentOpen] = useState(false);
  const [scheduleDate, setScheduleDate] = useState(null);
  const [avaliableMonths, setAvaliableMonths] = useState([]);
  const [selectedPayroll, setSelectedPayroll] = useState();

  const handlePayment = async (scheduleDate) => {
    try{
      const response = await schedulePayrollPayment(selectedPayroll, scheduleDate);
      if(response?.data?.successCount > 0 && response?.data?.failureCount === 0) {
        toast.success(scheduleDate ? 'Pagamento agendado com sucesso.' : 'Pagamento realizado com sucesso.');
      }

      if(response?.data?.failureCount > 0 && response?.data?.successCount > 0) {
        toast.error(`${response?.data?.failureCount} pagamentos não puderam ser processados.`);
      }

      if(response?.data?.successCount === 0) {
        toast.error('Nenhum pagamento pôde ser processado.');
      }
      
      setIsSchedulePaymentOpen(false);
      listPayrolls();
      getBalance();
    } catch(err) {
      console.log("err ", err);
      toast.error(err.response?.data?.message || 'Erro ao processar pagamento da folha');
      return;
    }
  }

  const openSchedulePayment = () => {
    setIsSchedulePaymentOpen(true);
  }

  useEffect(() => {
    if (!selectedPayroll) return;

    const payroll = payrolls?.find(p => p.id === selectedPayroll);
    getDetailedPayroll(payroll?.id);
  }, [selectedPayroll])

  useEffect(() => {
    if (payrolls && payrolls.length > 0) {
      const filteredPayrolls = payrolls.filter(p => p.status === 'LOCKED');
      if (filteredPayrolls.length > 0) {
        setAvaliableMonths(filteredPayrolls.map(p => {
          return {
            value: p.id,
            label: moment(`${p.referenceYear}-${p.referenceMonth}`).format('MMMM / YYYY')
          }
        }));
        setSelectedPayroll(filteredPayrolls[0].id);
      } else {
        setAvaliableMonths([]);
        setSelectedPayroll(null);
      }
    }
  }, [payrolls])

  useEffect(() => {
    listPayrolls();
    getBalance();
  }, [])

  return (
    <div className="payroll-payment-container">
      <div className="col-md-10">
        <div className="mt-4 mb-3">
          <PageHeader title="Pagamento de folha" pages={[{ name: 'Folha de pagamento', link: "/folha-pagamento/dashboard" }]} />
        </div>
        <section id="screen-payment" className="screen active screen-payment">
          <p className="subtitle">Use o saldo em conta para quitar a folha. </p>
          
          {(!payrolls || payrolls.length === 0 || avaliableMonths.length === 0) ? (
            <div className="empty-state">
              <div className="empty-state-icon">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M9 12h6m-6 4h6" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="empty-state-title">Nenhuma folha aguardando pagamento</h3>
              <p className="empty-state-description">
                Não há folhas de pagamento com status "Travada" aguardando pagamento no momento. 
                Finalize uma folha na página de Prévia para que ela apareça aqui.
              </p>
              <Link to="/folha-pagamento/previa" className="empty-state-button">
                Ir para Prévia de Folha
              </Link>
            </div>
          ) : (
            <>
              <div className="d-flex gap-2">
            <div className="panel">
              <div className="panel-header">
                <div>
                  <div className="panel-title">Resumo da folha</div>
                  <div className="panel-subtitle">Valores consolidados antes da quitação.</div>
                </div>
                <div>
                  <Select
                    options={avaliableMonths}
                    value={selectedPayroll}
                    onChange={setSelectedPayroll}
                    disabled={loading}
                  />
                </div>
              </div>
              {/* <div className="cards-row">
                <div className="payment-card">
                  <div className="card-title">Líquido aos colaboradores</div>
                  <div className="card-value">R$ 383.800, 00</div>
                </div>
                <div className="payment-card">
                  <div className="card-title">Encargos (INSS, FGTS, IRRF)</div>
                  <div className="card-value">R$ 158.900, 00</div>
                </div>
              </div> */}
              <div className="mb-4 mt-3">
                <span className="pill">Folha fechada • Aguardando pagamento</span>
              </div>
              <div className="cards-row">
                <div className="payment-card">
                  <div className="card-title">Total a pagar</div>
                  <div className="card-value">{formatValueToMonetary(Number(detailedPayroll?.payroll?.totalNet))}</div>
                </div>
              </div>
            </div>
            <div className="panel">
              <div className="panel-header">
                <div>
                  <div className="panel-title">Fonte de recursos</div>
                  <div className="panel-subtitle">Saldo disponível para funding.</div>
                </div>
              </div>
              <div className="cards-row">
                <div className="payment-card">
                  <div className="card-title">Saldo em conta</div>
                  <div className="card-value">{formatValueToMonetary(Number(avaliableBalance))}</div>
                </div>
              </div>
              <div className="d-flex gap-4">
                <button className="payroll-primary-button" onClick={() => handlePayment()}>
                  Realizar pagamento agora
                </button>
                <button className="payroll-secondary-button" onClick={openSchedulePayment}>Agendar pagamento</button>
              </div>
            </div>
          </div>
            </>
          )}
        </section>
      </div>

      <ReactModal
        isOpen={isSchedulePaymentOpen}
        className={'payroll-modal'}
        overlayClassName={'overlay-payroll-modal'}
        onRequestClose={() => setIsSchedulePaymentOpen(false)}
        ariaHideApp={false}
      >
        <Box
          title={"Agendar pagamento da folha"}
          description={"Selecione o dia para agendar o pagamento da folha de pagamento."}
          key={"payroll-modal"}
        >
          <div className="col-md-12">
            <label className="font-semibold text-sm">Dia para agendar</label>
            <input
              type="date"
              className="form-control"
              id="scheduleDateInput"
              value={scheduleDate || ""}
              min={moment().add(1, 'day').format('YYYY-MM-DD')}
              max={moment().add(30, 'day').format('YYYY-MM-DD')}
              onChange={(e) => setScheduleDate(e.target.value)}
            />
            <div className="d-flex justify-content-between mt-4">
              <button
                className="payroll-primary-button"
                onClick={() => handlePayment(scheduleDate)}
              >
                {loading ? "Agendando..." : "Agendar pagamento"}
              </button>
              <button
                className="payroll-secondary-action"
                onClick={() => setIsSchedulePaymentOpen(false)}
              >
                Cancelar
              </button>
            </div>
          </div>
        </Box>
      </ReactModal>
    </div>
  );
}
